import { runAction } from "./client";
import { assertValue } from "../app/utils/assert";

type Key = string | number;

export interface DeleteObjectsRequest
{
    Vehicle?: Key[];
    Sensor?: Key[]; 
}

export interface DeleteObjectsResult
{
    Success: boolean;
    ErrorMessage: string;
}

export interface DeleteObjectsFn
{
    (request: DeleteObjectsRequest): Promise<DeleteObjectsResult>;
}

export const deleteObjects: DeleteObjectsFn = (request: DeleteObjectsRequest) => {
    assertValue(request);
    return runAction<DeleteObjectsResult>('/action/DeleteObject', request);
};


// WEBPACK FOOTER //
// ./src/rest/DeleteObjects.ts